<template>
  <div>
    <div class="cert">
      <div class="cert__icon">
        <CertificateSVG class="cert__svg" />
      </div>

      <div class="cert__text">
        <h2 class="cert__title">Certificado de Conclusão</h2>
        <p class="cert__desc">
          <span v-if="!isCourseCertificateAvailable"
            >Conquiste seu certificado assistindo <strong>80%</strong> de cada aula.</span
          >

          <span v-else>
            Seu Certificado de Conclusão <b>está disponível!</b> Parabéns pela sua
            conquista!
          </span>
        </p>
      </div>
    </div>

    <ObtainCourseCertificateButtons
      :course="course"
      v-if="isCourseCertificateAvailable"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CertificateSVG from '@/components/svg/CertificateSVG';
import ObtainCourseCertificateButtons from '@/components/course/certificate/ObtainCourseCertificateButtons';

export default {
  components: {
    CertificateSVG,
    ObtainCourseCertificateButtons,
  },

  computed: {
    ...mapGetters('course', ['isCourseCertificateAvailable', 'course']),
  },
};
</script>

<style scoped lang="scss">
.cert {
  display: flex;
  align-items: center;
  text-align: left;
  border-radius: 5px;

  &:hover {
    background-color: darken(#fff, 3%);
  }

  &__icon {
    flex: 0 0 70px;
    padding: 10px;
    background-color: #ff8800;
    border-radius: 5px;
  }

  &__text {
    padding-left: 10px;
  }

  &__title {
    font-family: "Poppins";
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 5px;
  }

  &__desc {
    color: lighten(#000, 30%);
    font-size: 14px;
  }

  &__svg {
    fill: #fff;
  }
}
</style>
